const SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export async function launchGeneratorInDcc(authorization) {
  const value = authorization || {};
  const slug = String(value.launch_slug || value.source_generator_slug || '');
  if (value.delivery !== 'DCC_TAURI' || value.launch_command !== 'combat_pro_launch_generator' || !SLUG.test(slug)) {
    throw new Error('invalid_dcc_launch_authorization');
  }
  const invoke = typeof window !== 'undefined' && window.__TAURI_INTERNALS__
    && window.__TAURI_INTERNALS__.invoke;
  if (typeof invoke !== 'function') throw new Error('dcc_required');
  return invoke('combat_pro_launch_generator', { slug: slug });
}

export function generatorCommerceRoute(slug, action) {
  const params = new URLSearchParams({ generator: slug });
  params.set(action === 'buy' ? 'action' : 'view', action === 'buy' ? 'buy' : 'info');
  return '/dashboard/standalone-generators?' + params.toString();
}
